import { render, staticRenderFns } from "./InstallmentPlanEdit.vue?vue&type=template&id=05536b00&"
import script from "./InstallmentPlanEdit.vue?vue&type=script&lang=js&"
export * from "./InstallmentPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports